import type { FlowId } from './types';
import { accessGroupCreationFlow } from './accessGroupCreation.flow';
import { bulkUserImportFlow } from './bulkUserImport.flow';
import { deviceSetupFlow } from './deviceSetup.flow';
import { userCreationFlow } from './userCreation.flow';

const FLOW_REGISTRY = {
  'device-setup': deviceSetupFlow,
  'user-creation': userCreationFlow,
  'access-group-creation': accessGroupCreationFlow,
  'bulk-user-import': bulkUserImportFlow,
} as const;

export function getFlowDefinition(flowId: FlowId) {
  return FLOW_REGISTRY[flowId];
}
